import React from 'react';
import StepHeader from './StepHeader';
import StepContent from './StepContent';

/**
 * Wrapper component combining step header and content
 * @param {Object} props - Component props
 * @param {Object} props.step - Step configuration object
 * @param {string} props.status - Current step status
 * @param {boolean} props.isActive - Whether step is currently active
 * @param {boolean} props.canClick - Whether step header can be clicked
 * @param {Array} props.selections - Current step selections
 * @param {boolean} props.isCompleted - Whether step is completed
 * @param {boolean} props.isValid - Whether step has valid selections
 * @param {Function} props.onStepClick - Step click handler
 * @param {Function} props.onChange - Selection change handler
 * @param {Function} props.onNext - Next step handler
 * @returns {JSX.Element} Step component
 */
const Step = ({
  step,
  status,
  isActive,
  canClick,
  selections,
  selectionLabels,
  isCompleted,
  isValid,
  isRequired,
  isLastVisibleStep,
  onStepClick,
  onChange,
  onNext,
  onSkip,
  onForceRevalidation,
}) => {
  return (
    <div className={`overflow-hidden ${isActive ? 'border border-[#7cb305] rounded-[16px] bg-[#f8fdec]' : ''}`}>
      <StepHeader
        step={step}
        status={status}
        isActive={isActive}
        canClick={canClick}
        selections={selectionLabels}
        onStepClick={onStepClick}
      />

      <StepContent
        step={step}
        isActive={isActive}
        value={selections}
        isCompleted={isCompleted}
        isValid={isValid}
        isRequired={isRequired}
        isLastVisibleStep={isLastVisibleStep}
        onChange={onChange}
        onNext={onNext}
        onSkip={onSkip}
        onForceRevalidation={onForceRevalidation}
        selectionLabels={selectionLabels}
      />
    </div>
  );
};

export default Step;
